import PricingModal from './PricingModal';
import { getSubscriptionLimits } from '../utils/storage';

export default function UpgradeModal({ onClose, onToast }) {
  const limits = getSubscriptionLimits();
  const maxV = limits.maxVehicles === Infinity ? 'unlimited' : limits.maxVehicles;
  return (
    <PricingModal
      onClose={onClose}
      onToast={onToast}
      title="Vehicle Limit Reached"
      subtitle={`Your plan supports ${maxV} vehicle${limits.maxVehicles === 1 ? '' : 's'}. Upgrade for more.`}
    />
  );
}
